export function ValidaNomeComposto(nome: string): boolean {
    if (!nome) {
        return false;
    }

    // if current index is 0, verfify if the first name has at least 2 characters. for the other names, verify if they have at least 1 character otherwise return false
    return nome.trim()
        .split(' ')
        .every((nome: string, index: number): boolean => index === 0 ? nome.length >= 2 : nome.length >= 1);
}